"use client";

import Link from "next/link";

interface EmptyStateProps {
  icon: string;
  headline: string;
  description: string;
  action?: {
    label: string;
    href?: string;
    onClick?: () => void;
    icon?: string;
  };
  variant?: "default" | "filter" | "error";
  className?: string;
}

export function EmptyState({
  icon,
  headline,
  description,
  action,
  variant = "default",
  className = "",
}: EmptyStateProps) {
  const variantStyles = {
    default: "text-on-surface-variant",
    filter: "text-on-surface-variant",
    error: "text-error",
  };

  const iconBg = {
    default: "bg-primary/10",
    filter: "bg-surface-container-highest",
    error: "bg-error-container/40",
  };

  return (
    <div
      className={`flex flex-col items-center justify-center px-5 py-16 text-center ${className}`}
    >
      <div
        className={`h-16 w-16 ${iconBg[variant]} mb-4 flex items-center justify-center rounded-full`}
      >
        <span
          className={`material-symbols-outlined text-3xl ${variant === "error" ? "text-error" : "text-primary"}`}
        >
          {icon}
        </span>
      </div>
      <h3 className="text-on-surface mb-2 text-lg font-bold">{headline}</h3>
      <p className={`text-sm ${variantStyles[variant]} mb-6 max-w-xs`}>{description}</p>
      {action &&
        (action.href ? (
          <Link href={action.href} className="btn-primary inline-flex items-center gap-2">
            {action.icon && (
              <span className="material-symbols-outlined text-base">{action.icon}</span>
            )}
            {action.label}
          </Link>
        ) : (
          <button onClick={action.onClick} className="btn-primary inline-flex items-center gap-2">
            {action.icon && (
              <span className="material-symbols-outlined text-base">{action.icon}</span>
            )}
            {action.label}
          </button>
        ))}
    </div>
  );
}
